<script>
import moment from 'moment'
import CaregiverBehaviorRatingModel from '@/model/CaregiverBehaviorRatingModel'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  mixins: [GenericAPIHandler],
  props: {
    caregiverId: {
      type: Number,
      required: true,
    },
    detail: {
      type: Object,
      required: true,
    },
  },
  watch: {
    detail (formData, oldFormData) {
      this.getRating()
      this.createdAt = moment(formData.createdAt).format('DD/MM/YYYY, HH:mm')
      this.patient = `P${formData.patient.id} ${formData.patient.name}`
      this.comment = formData.comment
      this.type = formData.type
      this.behaviorType = formData.behaviorType
    },
  },
  data () {
    return {
      control: {
        showFeedBackDialog: false,
        showRatingDialog: false,
        showCancelEditDialog: false,
        showDeleteDialog: false,
        showSuccessDialog: false,
        showSuccessRemoveDialog: false,
      },
      type: '',
      behaviorType: '',
      currentRating: 0,
      query: '',
      pateintResults: [],
      timeout: null,
      patient: '',
      comment: '',
      createdAt: ''
    }
  },
  mounted () {
    this.getRating()
    this.createdAt = moment(this.detail.createdAt).format('DD/MM/YYYY, HH:mm')
    this.patient = `P${this.detail.patient.id} ${this.detail.patient.name}`
    this.comment = this.detail.comment
    this.type = ['good', 'bad'].includes(this.detail.behaviorType) ? 'feedback' : 'rating'
    this.behaviorType = !['good', 'bad'].includes(this.detail.behaviorType) ? 'adjustRating' : this.detail.behaviorType
  },
  methods: {
    handleType () {
      this.control.showCancelEditDialog = false
      this.control.showDeleteDialog = false
      if (this.type === 'feedback') {
        this.control.showFeedBackDialog = true
      } else {
        this.behaviorType = 'adjustRating'
        this.control.showRatingDialog = true
      }
    },
    handleCancel () {
      this.control.showFeedBackDialog = false
      this.control.showRatingDialog = false
      setTimeout(() => { this.control.showCancelEditDialog = true }, 300)
    },
    handleDelete () {
      this.control.showFeedBackDialog = false
      this.control.showRatingDialog = false
      setTimeout(() => { this.control.showDeleteDialog = true }, 300)
    },
    cancelForm () {
      this.control.showFeedBackDialog = false
      this.control.showRatingDialog = false
      this.control.showCancelEditDialog = false
      this.control.showDeleteDialog = false
      this.type = this.detail.type
      this.behaviorType = this.detail.type
      this.patient = `P${this.detail.patient.id} ${this.detail.patient.name}`
      this.comment = this.detail.comment
    },
    async getRating () {
      try {
        const raw = await this.$api.Caregiver.behaviorRating(this.caregiverId)
        const dashboard = CaregiverBehaviorRatingModel.fromJSON(raw)
        this.currentRating = dashboard.ratings
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async submit () {
      try {
        await this.$api.Caregiver.behaviorCommentUpdate(
          this.detail.id,
          parseInt(this.patient.match(/\d+/)[0], 10),
          this.comment,
        )
        this.$emit('getBehaviorCommentList')
        this.cancelForm()
        this.control.showSuccessDialog = true
        setTimeout(() => {
          this.control.showSuccessDialog = false
        }, 1500)
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async deleteItem () {
      try {
        await this.$api.Caregiver.behaviorCommentRemove(
          this.detail.id,
          this.caregiverId,
        )
        this.control.showDeleteDialog = false
        this.control.showSuccessRemoveDialog = true
        this.$emit('getBehaviorCommentList')
        this.cancelForm()
        setTimeout(() => {
          this.control.showSuccessRemoveDialog = false
        }, 1500)
      } catch (error) {
        if (error.response.data.msg === 'you can only delete the last comment' || error.response.data.error === 'you can only delete the last comment') {
          error.response.data.msg = 'ลบได้เฉพาะรายการล่าสุดนะของประเภทพฤติกรรมนั้นนะ'
        }
        this.cancelForm()
        this.showErrorDialog(error)
      }
    },
    async queryPatient (queryString, cb) {
      try {
        let queries = []
        if (queryString) {
          const raw = await this.$api.Caregiver.behaviorPatientSearch(queryString)
          queries = raw.map(r => ({ value: `P${r.id} ${r.name}` }))
        } else {
          queries = [{ value: 'โปรดกรอกข้อมูล' }]
        }

        this.pateintResults = queries.length === 0 ? [{ value: 'ไม่พบข้อมูล' }] : queries
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          cb(this.pateintResults)
        }, 1000 * Math.random())
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    handleAutocompletePatient (item) {
      if (item.value === 'ไม่พบข้อมูล' || item.value === 'โปรดกรอกข้อมูล') {
        this.patient = ''
      }
    },
  },
}
</script>

<template>
  <div class="comment-container">
    <div class="title">
      <div
        v-if="detail.behaviorType === 'good'"
        class="badge good-feedback"
      >
        <img
            src="https://storage.healthathome.in.th/90c6c3fc-2030-48ed-b390-eb28e8fe2d60.svg"
            alt="good-feedback"
            width="14" height="14"
        >
        ฟีดแบ็คดี
      </div>
      <div
        v-else-if="detail.behaviorType === 'bad'"
        class="badge bad-feedback"
      >
        <img
            src="https://storage.healthathome.in.th/bec2abe4-2ad7-478e-af19-d1b5b8ba6dd0.svg"
            alt="bad-feedback"
            width="14" height="14"
        >
        ฟีดแบ็คไม่ดี
      </div>
      <div
        v-else-if="detail.behaviorType === 'decrease'"
        class="badge decrease-rating"
      >
        <img
            src="https://storage.healthathome.in.th/68eeae22-3212-4c32-bab0-91db00529d23.svg"
            alt="decrease-rating"
            width="14" height="14"
        >
        หักคะแนน
      </div>
      <div
        v-else-if="detail.behaviorType === 'increase'"
        class="badge increase-rating"
      >
        <img
            src="https://storage.healthathome.in.th/51777c95-ef50-4345-abb2-8310dfd4bab5.svg"
            alt="decrease-rating"
            width="14" height="14"
        >
        คืนคะแนน
      </div>
      <span class="customer">P{{ detail.patient.id }} {{ detail.patient.name }}</span>
      <span class="date">{{ createdAt }}</span>
    </div>
    <div class="content">{{ detail.comment }} {{ detail.behaviorType === 'increase' ? `(+${detail.changeRating} ดวง)` : '' }} {{ detail.behaviorType === 'decrease' ? `(${detail.changeRating} ดวง)` : '' }}</div>
    <img
      src="https://storage.healthathome.in.th/8db0f0a3-5385-4b67-b8b4-fb836f04163b.svg"
      alt="edit"
      class="edit-icon"
      @click="
        handleType()
      "
    />

    <!-- Feedback Dialog -->
    <el-dialog
        :visible.sync="control.showFeedBackDialog" :showClose="false"
        :closeOnClickModal="false" style="margin-top: 5vh;" width="30%"
    >
      <div style="display: flex; align-items: flex-start; flex-direction: column; align-items: flex-start;">
        <div class="header-18" style="margin-bottom: 40px;">ฟีดแบ็ค</div>
        <div style="display: flex; flex-direction: row; gap: 24px;">
          <div class="title">
            ประเภท
          </div>
          <el-radio-group
              disabled
              class="group-vertical radio"
              v-model="behaviorType"
              style="padding-top: 7px; display: flex; flex-direction: column;"
          >
            <el-radio label="good" style="margin-bottom: 12px;">ฟีดแบ็คดี</el-radio>
            <el-radio label="bad">ฟีดแบ็คไม่ดี</el-radio>
          </el-radio-group>
        </div>
        <div style="margin-top: 44px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            เคส
          </div>
          <el-autocomplete
            class="hospital auto-complete-hospital"
            style="width: 100%;"
            :disabled="false"
            v-model="patient"
            placeholder="เลขคนไข้ หรือ ชื่อผู้ติดต่อ"
            :fetch-suggestions="queryPatient"
            @select="handleAutocompletePatient"
            suffix-icon="el-icon-search"
          ></el-autocomplete>
        </div>
        <div style="margin-top: 24px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            รายละเอียด
          </div>
          <el-input
              type="textarea"
              :rows="3"
              v-model="comment"
              placeholder="รายละเอียดฟีดแบ็ค"
          ></el-input>
        </div>
      </div>
      <span class="dialog-footer" slot="footer" style="margin-top: 10px;">
        <div class="button-container">
          <el-button
              type="primary"
              @click="handleDelete()"
              plain="plain"
              icon="el-icon-delete"
              class="delete-button"
              style="display: flex;"
          >
            ลบ
          </el-button>
          <div>
            <el-button
              class="secondary-button"
              @click="handleCancel()"
              plain="plain"
            >
              ยกเลิก
            </el-button>
            <el-button
              class="edit"
              type="primary"
              @click="submit()"
              :disabled="patient.trim().length === 0 || comment.trim().length === 0"
            >
              บันทึก
            </el-button>
          </div>
        </div>
      </span>
    </el-dialog>

    <!-- Rating Dialog -->
    <el-dialog
      :visible.sync="control.showRatingDialog" :showClose="false"
      :closeOnClickModal="false" style="margin-top: 5vh;" width="30%"
    >
      <div style="display: flex; align-items: flex-start; flex-direction: column; align-items: flex-start;">
        <div class="header-18" style="margin-bottom: 40px;">คะแนนหัวใจ</div>
        <div style="display: flex; flex-direction: row; gap: 24px;">
          <div class="title" style="color: #D5D6DB;">
            คะแนนหัวใจ
          </div>
          <div class="rating-container">
            <div class="heart-container">
              <div
                v-for="(_, index) in new Array(5)"
                :key="'rating-' + index"
                class="heart"
              >
                <img
                  v-if="currentRating >= index + 1"
                  src="https://storage.healthathome.in.th/5486f569-a587-41c9-8aaa-41f61e78f175.svg"
                  alt="selected"
                />
                <img
                  v-else
                  src="https://storage.healthathome.in.th/4c5269b4-dc91-404e-af29-70898840fec5.svg"
                  alt="not-selected"
                />
              </div>
            </div>
            <div class="box">คะแนนหัวใจปัจจุบัน: {{ currentRating }}</div>
          </div>
        </div>
        <div style="margin-top: 44px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            เคส
          </div>
          <el-autocomplete
              class="hospital auto-complete-hospital"
              style="width: 100%;"
              :disabled="false"
              v-model="patient"
              placeholder="เลขคนไข้ หรือ ชื่อผู้ติดต่อ"
              :fetch-suggestions="queryPatient"
              @select="handleAutocompletePatient"
              suffix-icon="el-icon-search"
          ></el-autocomplete>
        </div>
        <div style="margin-top: 24px; display: flex; flex-direction: row; gap: 24px; width: 100%;">
          <div class="title">
            รายละเอียด
          </div>
          <el-input
              type="textarea"
              :rows="3"
              v-model="comment"
              placeholder="รายละเอียดความดีหรือความผิด"
          ></el-input>
        </div>
      </div>
      <span class="dialog-footer" slot="footer" style="margin-top: 10px;">
        <div class="button-container">
          <el-button
            type="primary"
            @click="handleDelete()"
            plain="plain"
            icon="el-icon-delete"
            class="delete-button"
            style="display: flex;"
          >
            ลบ
          </el-button>
          <div>
            <el-button
              class="secondary-button"
              @click="handleCancel()"
              plain="plain"
            >
              ยกเลิก
            </el-button>
            <el-button
              class="edit"
              type="primary"
              @click="submit()"
              :disabled="patient.trim().length === 0 || comment.trim().length === 0"
            >
              บันทึก
            </el-button>
          </div>
        </div>
      </span>
    </el-dialog>

    <!-- Cancel Edit Dialog -->
    <el-dialog :visible.sync="control.showCancelEditDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการแก้ไขข้อมูล ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button
            class="secondary-button"
            @click="handleType()"
            plain="plain"
        >
          ยกเลิก
        </el-button>
        <el-button type="primary" @click="cancelForm()" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Delete Dialog -->
    <el-dialog :visible.sync="control.showDeleteDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px;">คุณต้องการลบข้อมูลรายการนี้ ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button
            class="secondary-button"
            @click="handleType()"
            plain="plain"
        >
          ยกเลิก
        </el-button>
        <el-button type="primary" @click="deleteItem()" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>

    <!-- Success Update Dialog -->
    <el-dialog :visible.sync="control.showSuccessDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div style="margin-left: 17px; display: flex; flex-direction: column;">
          <div class="dialog-header-18">เย่! แก้ไขข้อมูลเรียบร้อย</div>
        </div>
      </div>
    </el-dialog>

    <!-- Success Remove Dialog -->
    <el-dialog :visible.sync="control.showSuccessRemoveDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; align-items: center; margin-top: 30px;  margin-bottom: 35px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/faa9aca8-773e-44a3-b4cf-558d8e173c21.svg" />
        <div style="margin-left: 17px; display: flex; flex-direction: column;">
          <div class="dialog-header-18">ลบข้อมูลเรียบร้อย!</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<style lang="scss">
  .el-dialog__body {
    padding: 40px 56px !important;
  }

  .el-input__inner {
    font-size: 18px;

    &::placeholder {
      color: #D5D6DB;
      font-family: "Sukhumvit-Medium";
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
</style>

<style scoped lang="scss">
  .comment-container {
    display: grid !important;
    grid-template-columns: 240px 1fr 16px;
    gap: 16px;
    width: 100%;

    .title {
      display: flex;
      flex-direction: column;

      .badge {
        display: flex;
        padding: 2px 12px;
        align-items: center;
        gap: 8px;
        border-radius: 99px;
        font-family: "Sukhumvit-SemiBold";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 21.6px;
        width: fit-content;

        &.good-feedback {
          background: #DBFFFC;
          color: #60B8B2;
        }

        &.bad-feedback {
          background: #FFEEF2;
          color: #FF577F;
        }

        &.decrease-rating {
          background: #E9EAED;
          color: #434B61;
        }

        &.increase-rating {
          background: #EDF3FF;
          color: #5489FF;
        }
      }

      .customer {
        margin-top: 8px;
        color: #434B61;
        font-family: "Sukhumvit-Bold";
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      .date {
        color: #A2A7B2;
        font-family: "Sukhumvit-Medium";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }

    .content {
      color: #434B61;
      font-family: "Sukhumvit-Medium";
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      white-space: pre-line;
    }

    .edit-icon {
      cursor: pointer;
      transition-duration: .3s;

      &:hover {
        opacity: 0.75;
      }
    }
  }

  .header-18 {
    font-family: 'Sukhumvit-Bold';
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #434B61;
  }

  .cancel-button {
    min-width: 80.92px;
    border: 1.5px solid #409EFF !important;
    transition: .2s;
    span {
      color: #409EFF;
      transition: .2s;
    }
    &:hover {
      background: #409EFF !important;
      transition: .2s;
      span {
        color: #FFFFFF;
        transition: .2s;
      }
    }
  }

  .title {
    color: #434B61;
    font-family: 'Sukhumvit-Medium';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px;
    min-width: 81px;
  }

  .rating-container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .heart-container {
      display: flex;
      flex-direction: row;
      gap: 4px;

      .heart {
        width: 40px;
        height: 40px;
        background-color: transparent;
        cursor: not-allowed;
      }
    }

    .box {
      padding: 8px 16px;
      width: auto;
      background-color: #F1F3F6;
      border-radius: 4px;
      color: #A2A7B2;
      font-family: "Sukhumvit-SemiBold";
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px;
    }
  }

  .button-container {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }
</style>
